import PropTypes from 'prop-types';
import React from 'react';
import Helmet from 'react-helmet';

const getEnv = () => {
  const [prefix] = window.location.host.split('.');
  if (prefix === 'localhost:3010') {
    return 'LOCAL';
  }

  if (['dev', 'tst', 'qas'].includes(prefix)) {
    return prefix.toUpperCase();
  }
  return null;
};

const Title = ({ title, suffix = 'CTS operations in the cloud', children }) => {
  const env = getEnv();
  return (
    <>
      <Helmet>
        <title>{`${title ? `${title} |` : ''}${env ? ` ${env} |` : ''} ${suffix}`}</title>
        {env ? <meta name='environment' content={env} /> : null}
      </Helmet>
      {children}
    </>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  suffix: PropTypes.string,
  children: PropTypes.node,
};

export default Title;
